export default __webpack_public_path__ + "a22c7a82cf20df161a0a205f420b8d2c.png";